import _extends from "@babel/runtime/helpers/extends";
import { Box, Text } from '@wix/design-system';
import React from 'react';
import { useCurrentModule } from '../../ModuleProvider';
import styles from '../RevShare.scss';
export const RevShareSectionHelper = _ref => {
  let {
    formattedAmount,
    ...boxProps
  } = _ref;
  const module = useCurrentModule();
  const {
    Trans
  } = module.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, _extends({
    dataHook: "revshare-section-helper",
    padding: "SP2 32px",
    borderRadius: "8px",
    backgroundColor: "#f7edfc"
  }, boxProps), /*#__PURE__*/React.createElement(Text, {
    weight: "normal",
    size: "small",
    dataHook: "revshare-section-helper-text"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "cycle_entry.yearly_multi.revshare.section_helper",
    components: {
      strong: /*#__PURE__*/React.createElement(Text, {
        size: "small",
        weight: "bold",
        className: styles.revShareAmount
      })
    },
    values: {
      amountEarned: formattedAmount
    }
  })));
};
//# sourceMappingURL=RevShareSectionHelper.js.map